import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { NONROTNewRequestComponent } from './new-request/new-request.component';
import { NotObjectedNotificationRightsObligationsTransferRoutingModule } from './not-objected-notification-rights-obligations-transfer-routing.module';
import { NONROTNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [NONROTNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    NotObjectedNotificationRightsObligationsTransferRoutingModule,
  ],
  providers: [NONROTNewRequestFormService],
})
export class NotObjectedNotificationRightsObligationsTransferModule {}
